'use client'

// import { Document, Page, pdfjs } from 'react-pdf'

// import 'react-pdf/dist/Page/AnnotationLayer.css'
// import 'react-pdf/dist/Page/TextLayer.css'

// Configure worker
// pdfjs.GlobalWorkerOptions.workerSrc = new URL(
//   'pdfjs-dist/build/pdf.worker.min.mjs',
//   import.meta.url,
// ).toString()

const PDFViewer = ({ url }: { url: string }) => {
  return <embed height="100%" src={url} type="application/pdf" width="100%" />

  //   return (
  //     <div className="flex flex-col items-center p-4">
  //       <Document file={url} onLoadSuccess={onDocumentLoadSuccess} className="max-w-full">
  //         {Array.from(new Array(numPages), (el, index) => (
  //           <Page
  //             key={`page_${index + 1}`}
  //             pageNumber={index + 1}
  //             className="mb-4 shadow-md"
  //             width={300} // Adjust width as needed for the sidebar
  //             renderTextLayer={false}
  //             renderAnnotationLayer={false}
  //           />
  //         ))}
  //       </Document>
  //     </div>
  //   )
}

export default PDFViewer
